var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.formLoading,
          expression: "formLoading",
        },
      ],
      ref: "userItaProfileForm",
      attrs: { model: _vm.user },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "帳號" } },
        [
          _c("el-input", {
            attrs: { disabled: true },
            model: {
              value: _vm.user.account,
              callback: function ($$v) {
                _vm.$set(
                  _vm.user,
                  "account",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "user.account",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "名稱" } },
        [
          _c("el-input", {
            attrs: { disabled: _vm.checkPermission(["ITA-TRAVEL-AGENCY"]) },
            model: {
              value: _vm.user.name,
              callback: function ($$v) {
                _vm.$set(
                  _vm.user,
                  "name",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "user.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "更改密碼", prop: "password" } },
        [
          _c(
            "span",
            {
              staticClass: "show-pwd",
              staticStyle: { "margin-left": "10px" },
              on: { click: _vm.showPwd },
            },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class":
                    _vm.passwordType === "password" ? "eye" : "eye-open",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-tag",
                {
                  staticStyle: {
                    height: "auto",
                    "white-space": "break-spaces",
                    "font-size": "14px",
                  },
                  attrs: { type: "warning" },
                },
                [_vm._v("密碼原則：密碼必須包含英文，數字及長度介於6-16之間")]
              ),
            ],
            1
          ),
          _c("el-input", {
            ref: "password",
            attrs: {
              type: _vm.passwordType,
              placeholder: "請輸入密碼",
              autocomplete: "off",
            },
            model: {
              value: _vm.user.password,
              callback: function ($$v) {
                _vm.$set(_vm.user, "password", $$v)
              },
              expression: "user.password",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              staticStyle: { color: "#4b4b4b" },
              attrs: { type: "warning" },
              on: { click: _vm.submit },
            },
            [_vm._v("儲 存")]
          ),
        ],
        1
      ),
      _vm.errorMsg
        ? _c(
            "el-form-item",
            [
              _c("el-alert", {
                attrs: { closable: false, title: _vm.errorMsg, type: "error" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }